import React, { useState, useRef } from "react";
import MyHeader from "./Header.module.css";
import HeaderAvatar from "../Avatar/HeaderAvatar";
import { useSelector, useDispatch } from "react-redux";
import { closeShareModal, closeVersionModal } from '../../app/EditorSlice';
import DocumentMembers from "../Members/members";
import MembersDropdown from "../Members/MembersDropdown";
import MembersGroup from "../Members/MembersGroup";
import Modes from '../Modes';
import TemplateActiveToggle from '../TemplateToggle/TemplateActiveToggle';
import AppLauncher from '../AppLauncher';
import OfflineToggle from '../OfflineToggle';
import VersionModalContent from "../DocumnetVersion/VersionsModal/versionModalContent.js";
import VersionsModal from "../DocumnetVersion/VersionsModal/versionsModal.js";
import CompleteDocument from "../CompleteDoc/completeDoc.js";
import { ShareModalContent } from "../ShareModal/ShareModalContent/ShareModalContent";
import { ShareModal } from "../ShareModal/ShareModal";
import { Dropdown, Modal, Drawer } from 'antd';
import TemplateThumbnail from '../TemplateThumbnail/templateThumbnail';
import HeaderMenu from './HeaderMenu';

const RightHeader = ({ isMobile, leftRef, leftActionsRef }) => {
    const dispatch = useDispatch();
    const shareModalOpen = useSelector((state) => state.editor.modals.share);
    const versionDrawerOpen = useSelector((state) => state.editor.modals.version);
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    const userInformation = useSelector((state) => state.editor.userInformation);
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
    const members = (documentInformation?.members || []).filter(m => m.id !== userInformation?.userId);
    const [showAppLauncher, setShowAppLauncher] = useState(false);
    const [membersDrawerOpen, setMembersDrawerOpen] = useState(false);
    const [membersDropdownVisible, setMembersDropdownVisible] = useState(false);
    const [sharePrivacy, setSharePrivacy] = useState(0);

    const titleBarRef = useRef(null);

    return (
        <>
            <div className={MyHeader.rightHeader}>
                <div className={MyHeader.titleBarButtons} ref={titleBarRef}>
                    {isTemplateDocument && (
                        <div className={`${MyHeader.iconContainer} ${MyHeader.switchContainer}`}>
                            <TemplateActiveToggle />
                        </div>
                    )}
                    {isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <TemplateThumbnail />
                        </div>
                    )}
                    {!isReadOnly && !isTemplateDocument && (
                        <div className={`${MyHeader.iconContainer} ${MyHeader.offlineContainer}`}>
                            <OfflineToggle scale={0.8} />
                        </div>
                    )}
                    {/* Member group (desktop only)*/}
                    {!isMobile && members.length > 0 && !isTemplateDocument && (
                        <div className={MyHeader.titleBarItem}>
                            <Dropdown overlay={<MembersDropdown />} trigger={['click']} visible={membersDropdownVisible} onVisibleChange={(vis) => setMembersDropdownVisible(vis)} placement="bottomRight">
                                <div
                                    className={`${MyHeader.memberGroup} ${MyHeader.memberButton}`}
                                    title="Members"
                                    role="button"
                                    tabIndex={0}
                                >
                                    <div className="member-avatar-container" style={{ width: 30 }}><MembersGroup size={24} /></div>
                                </div>
                            </Dropdown>
                        </div>
                    )}
                    {!isReadOnly && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <CompleteDocument />
                        </div>
                    )}
                    {!isReadOnly && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <VersionsModal leftRef={leftActionsRef} />
                        </div>
                    )}
                    {!isReadOnly && documentInformation.createBy == userInformation.userId && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <ShareModal />
                        </div>
                    )}
                    <div className={MyHeader.iconContainer}>
                        <AppLauncher open={showAppLauncher} onOpenChange={setShowAppLauncher} scale={0.8} />
                    </div>
                    <div className={MyHeader.iconContainer}>
                        <Modes isMobile={isMobile} />
                    </div>
                    <div className={`${MyHeader.iconContainer} ${MyHeader.avatarIconContainer}`}>
                        <HeaderAvatar />
                    </div>
                    <div className={`${MyHeader.iconContainer} ${MyHeader.hamburger}`}>
                        <HeaderMenu onOpenAppLauncher={() => setShowAppLauncher(true)} />
                    </div>
                    {/* Mobile-only avatar placed after hamburger so profile avatar is visible on the right */}
                    <div className={`${MyHeader.iconContainer} ${MyHeader.avatarMobile}`}>
                        <HeaderAvatar />
                    </div>
                </div>
            </div>
            <Modal
                title={"Share with people and Groups"}
                visible={shareModalOpen}
                onOk={() => dispatch(closeShareModal())}
                onCancel={() => dispatch(closeShareModal())}
                footer={false}
            >
                <ShareModalContent shareUrl={null} setIsModalVisible={() => dispatch(closeShareModal())} privacy={sharePrivacy} setPrivacy={setSharePrivacy} />
            </Modal>

            <Drawer title="Version history" placement="right" onClose={() => dispatch(closeVersionModal())} visible={versionDrawerOpen}>
                <div>
                    <VersionModalContent open={versionDrawerOpen} setOpen={() => dispatch(closeVersionModal())} setShowVersionButtons={() => { }} />
                </div>
            </Drawer>

            <Drawer title="Members" placement="right" onClose={() => setMembersDrawerOpen(false)} visible={membersDrawerOpen}>
                <div>
                    <DocumentMembers />
                </div>
            </Drawer>
        </>
    );
};

export default RightHeader;